// extracted by mini-css-extract-plugin
export var borderRadius = "_6n-4";
export var large = "_6n-3";
export var logoContainer = "_6n-0";
export var nameLogo = "_6n-2";
export var small = "_6n-1";